import { render, staticRenderFns } from "./awrUnscramble.vue?vue&type=template&id=87a05cee&scoped=true&"
import script from "./awrUnscramble.vue?vue&type=script&lang=js&"
export * from "./awrUnscramble.vue?vue&type=script&lang=js&"
import style0 from "./awrUnscramble.vue?vue&type=style&index=0&id=87a05cee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a05cee",
  null
  
)

component.options.__file = "awrUnscramble.vue"
export default component.exports